import { actionClient } from '@/api'

const state = {
  collection: [],
  pagination: {},
  total: 0
}

// actions
const actions = {
  async collection({ commit, dispatch, state }, query) {
    const data = await actionClient.get('member/activity/products', { query })
    commit('setProducts', data)
    return state
  },
}


// mutations
const mutations = {
  setProducts(state, data) {
    state.collection = data.collection,
    state.pagination = data.meta.pagination,
    state.total = data.meta.total
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
